import React from "react";
import { AppContextInterface } from "types/appContext";

export const AppContext = React.createContext<AppContextInterface>({
  tenant: null,
});
